(function (ng) {
    /// <summary>
    /// Service to return evo trip Traveler objects.
    /// May be expanded in the future to fetch existing travelers
    /// </summary>
    ng.module('evo.Trip.Services').factory('travelerService', [function () {
        return {
            getNewTraveler: function () {
                return {
                    ArrivingSoonerOrStayingLater: false,
                    Birthdate: null,
                    CustomerReferral: '',
                    DietaryRestrictions: '',
                    EmailAddress: '',
                    FirstName: '',
                    Gender: '',
                    InstagramHandle: '',
                    LastName: '',
                    NeedsRentalEquipment: false,
                    PhoneNumber: '',
                    PrefersSingleRoom: false,
                    QuestionsAndConcerns: '',
                    TravelMethod: '',
                    TravelPartner: ''
                }
            }
        };
    }]);
})(angular);